import React from "react";
import { Clock3, Sparkles, Plane } from "lucide-react";

const ComingSoonSection = () => {
  return (
    <section className="relative overflow-hidden py-24 px-5 sm:px-8 lg:px-12 bg-[#f8f6ef]">

      <div className="absolute inset-0 opacity-40">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `
              linear-gradient(to right, rgba(15,23,42,0.05) 1px, transparent 1px),
              linear-gradient(to bottom, rgba(15,23,42,0.05) 1px, transparent 1px)
            `,
            backgroundSize: "80px 80px",
          }}
        />

        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[300px] bg-voyage-cyan/20 blur-3xl rounded-full"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">

        <div className="grid lg:grid-cols-2 gap-14 items-center">

          <div>

            <div className="inline-flex items-center gap-2 bg-white border border-[#efd372] px-5 py-3 rounded-full shadow-sm mb-8">
              <Sparkles size={16} className="text-voyage-cyan" />

              <span className="text-[12px] font-black tracking-[0.25em] uppercase text-voyage-cyan">
                MVP Launching Soon
              </span>
            </div>

            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-tight tracking-tight text-slate-primary mb-8">
              Smarter Reward Point
              <br />

              Redemption Tools
              <br />

              Launching Soon
            </h2>

            <p className="text-slate-600 text-lg leading-9 max-w-2xl mb-10">
              Just For Points helps travelers compare reward point values,
              discover better flight redemption opportunities, analyze
              travel card transfer partners, and maximize airline and hotel
              point redemptions with smarter travel insights.
            </p>

            
            <div className="bg-white/70 border border-slate-200 rounded-3xl p-6 backdrop-blur-xl shadow-[0_10px_40px_rgba(15,23,42,0.08)]">

              <div className="flex items-center gap-3 mb-4">
                <Clock3 className="text-voyage-cyan" size={24} />

                <h3 className="text-2xl font-black text-slate-primary">
                  Public MVP Launch
                </h3>
              </div>

              <p className="text-slate-700 leading-8 text-lg">
                We’re preparing to launch our first MVP within the next
                <span className="font-black text-slate-primary">
                  {" "}fews weeks.
                </span>

                Early users will get access to exclusive travel reward
                optimization tools, redemption calculators, transfer partner
                analysis, and smarter flight deal suggestions.
              </p>
            </div>
          </div>

          {/* Right */}
          <div className="relative">

            <div className="bg-white/70 border border-slate-200 rounded-[2rem] p-8 backdrop-blur-xl shadow-[0_10px_40px_rgba(15,23,42,0.08)] relative overflow-hidden">

              {/* Glow */}
              <div className="absolute top-0 right-0 w-48 h-48 bg-voyage-cyan/20 blur-3xl rounded-full"></div>

              {/* Header */}
              <div className="flex items-center justify-between mb-8 relative z-10">

                <div>
                  <p className="text-slate-500 text-sm font-semibold">
                    Estimated Redemption Value
                  </p>

                  <h3 className="text-5xl font-black mt-2 text-slate-primary">
                    2.4¢
                  </h3>
                </div>

                <div className="w-16 h-16 rounded-3xl bg-gradient-to-br from-voyage-cyan to-[#f5c542] flex items-center justify-center shadow-xl">
                  <Plane className="text-space-dark" size={28} />
                </div>
              </div>

              {/* Features */}
              <div className="space-y-5 relative z-10">

                <div className="bg-[#fff7dc] border border-[#efd372] rounded-2xl p-5 flex justify-between items-center">
                  <div>
                    <p className="font-bold text-slate-primary">
                      Credit Card Transfer Analysis
                    </p>

                    <p className="text-slate-500 text-sm">
                      Discover higher-value transfer opportunities
                    </p>
                  </div>

                  <span className="text-voyage-cyan font-black text-xl">
                    +32%
                  </span>
                </div>

                <div className="bg-white border border-slate-200 rounded-2xl p-5 flex justify-between items-center">
                  <div>
                    <p className="font-bold text-slate-primary">
                      Flight Redemption Suggestions
                    </p>

                    <p className="text-slate-500 text-sm">
                      Smarter route recommendations
                    </p>
                  </div>

                  <span className="text-green-600 font-black text-lg">
                    Best Deal
                  </span>
                </div>

                <div className="bg-white border border-slate-200 rounded-2xl p-5">

                  <div className="flex justify-between mb-3">
                    <span className="font-semibold text-slate-600">
                      Potential Savings
                    </span>

                    <span className="font-black text-slate-primary">
                      78%
                    </span>
                  </div>

                  <div className="w-full bg-slate-200 rounded-full h-4 overflow-hidden">
                    <div className="h-full w-[78%] rounded-full bg-gradient-to-r from-voyage-cyan to-[#f5c542]"></div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ComingSoonSection;